/**
 * 계정 설정 화면의 탭 구분입니다.
 *
 * 서버 검증 오류나 저장 성공 안내는 해당 작업을 수행한 탭에만 보여야 합니다.
 * 하나의 문자열 상태를 모든 탭이 공유하면, 공통 프로필 오류가 복구 이메일 탭에
 * 표시되는 것처럼 서로 다른 기능의 안내가 섞일 수 있습니다.
 */
export type AccountTab = 'summary' | 'profile' | 'password' | 'recoveryEmail'

export type AccountNoticeTone = 'success' | 'error'

export interface AccountNotice {
  text: string
  tone: AccountNoticeTone
}

export type AccountNoticeState = Partial<Record<AccountTab, AccountNotice>>

/** 지정한 탭의 안내만 추가하거나 교체합니다. 다른 탭의 안내는 건드리지 않습니다. */
export function setAccountNotice(
  state: AccountNoticeState,
  tab: AccountTab,
  text: string,
  tone: AccountNoticeTone,
): AccountNoticeState {
  return {
    ...state,
    [tab]: { text, tone },
  }
}

/** 지정한 탭의 안내만 제거합니다. */
export function clearAccountNotice(
  state: AccountNoticeState,
  tab: AccountTab,
): AccountNoticeState {
  if (!state[tab]) return state
  const next = { ...state }
  delete next[tab]
  return next
}

/** 현재 탭에 속한 안내만 반환합니다. */
export function accountNoticeForTab(
  state: AccountNoticeState,
  tab: AccountTab,
): AccountNotice | null {
  return state[tab] ?? null
}

/** 모든 탭의 안내를 한 번에 제거합니다. 탭 전환 시 이전 작업 안내가 남지 않게 합니다. */
export function clearAllAccountNotices(): AccountNoticeState {
  return {}
}
